module.exports = __webpack_public_path__ + "static/media/newscontent_bg.191c23d4.png";